<script lang="ts">
    import type {ChatMessageAttachmentData} from "../../Types";
    import type {MessageVoiceNote} from "./Types";
    import {authBlobUrl} from "../../Auth";
    import InView from "../InView.svelte";
    import FormattedText from "./FormattedText.svelte";

    export let entity: MessageVoiceNote
    export let attachments: ChatMessageAttachmentData[]
</script>
<FormattedText entity={entity.caption}/>
<div class="alert alert-warning m-0">
    Аудіо повідомлення тривалістю {entity.voice_note.duration} секунд.<br>
{#if attachments && attachments.length}
    {#each attachments as attachment}
        {#if attachment.telegram_remote_attachment_id == entity.voice_note.voice.remote.id}
            {#if attachment.status === 'pending'}
                Запис ще не викачаний
            {:else if attachment.status === 'failed'}
                Запис викачати не вдалось
            {:else if attachment.status === 'success'}
                <InView>
                {#await authBlobUrl('/attachments/'+attachment.id)}
                    <div class="spinner-grow"></div>
                {:then src}
                    {#if src}
                        <audio controls style:width="100%">
                            <source {src} type="{entity.voice_note.voice.mime_type}">
                        </audio>
                    {:else}
                        Не вдалось завантажити.
                    {/if}
                {:catch error}
                    Не вдалось завантажити.
                {/await}
                </InView>
            {/if}
        {/if}
    {/each}
{:else}
    Не викачано
{/if}
</div>
